<template>
  <div>
    <el-form-item class="ai-items" label="词汇列表">
      <div class="ai-item-wrap" v-for="(item, key) in form.list" :key="item.id">
        <div class="ai-item">
          <div class="flex1">
            <div class="flex-row">
              <el-input :value="item.id" class="ai-item-no mr8" title="数据唯一值，自动生成" disabled/>
              <WordSelect v-model="item.word_id" class="flex1" @select="handleSelect(item, $event)"/>
            </div>
            <div v-for="(synonym, six) in item.synonyms" :key="six" class="mt8">
              <div class="flex-row">
                <div class="ai-item-no mr8 text-right">
                  多答案{{six + 1}}
                </div>
                <div class="flex1">
                  <div class="flex-row">
                    <el-input v-model="synonym.text" placeholder="文本" class="mr8"/>
                    <el-input v-model="synonym.pinyin" placeholder="拼音" class="mr8"/>
                    <el-input v-model="synonym.text_chivox" placeholder="语音文本" class="mr8"/>
                    <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeSynonym(item, six)"></el-button>
                  </div>
                  <div class="mt8 flex-row">
                    <FileInput v-model="synonym.audio" accept="audio/*" label="文本音频" class="flex1 mr8"></FileInput>
                    <el-button icon="el-icon-plus" tabindex="-1" @click="addSynonym(item, six)"></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-button icon="el-icon-document-add" tabindex="-1" @click="addSynonym(item)"></el-button>
          <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
          <el-button icon="el-icon-plus" tabindex="-1" @click="addItem(key)"></el-button>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import baseList from "./base-list.js";
import WordSelect from "@/components/word/WordSelect.vue";
import FileInput from "@/components/FileInput.vue";
export default {
  name: "ai_word_trans_form",
  components: {FileInput, WordSelect},
  props: {
    form: Object
  },
  data() {
    return {
      type: 2,
    }
  },
  mixins: [baseList],
  watch: {
    form: {
      immediate: true,
      handler(val) {
        if (!val.list) {
          val.list = [];
        }
        if (val.length < 1) {
          this.addItem(0);
        }
      }
    }
  },
  methods: {
    handleSelect(item, word) {
      item.text = word.text;
    },
    addSynonym(item, idx) {
      if (!item.synonyms) {
        this.$set(item, 'synonyms', []);
      }
      if (idx === undefined) {
        item.synonyms.push({});
      } else {
        item.synonyms.splice(idx, 0, {});
      }
    },
    removeSynonym(item, idx) {
      item.synonyms.splice(idx, 1);
    }
  }
}
</script>